import { Component, inject, OnInit, signal } from '@angular/core';
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonRouterLink, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { WorkUsersV2Service, WorkUserV2 } from 'libs/work-rest-api/src';
import { lastValueFrom } from 'rxjs';
import { RouterLink } from '@angular/router';
import dayjs from 'dayjs';
import { InfoblockComponent } from '@work-frontend-monorepo/work-ui/data-display';
import { PrependServerToFileSrcPipe } from '@work-frontend-monorepo/work-ui/pipes';
import { ExceptionHandlingService } from '@work-frontend-monorepo/work-ui/services';

@Component({
  selector: 'sfg-app-mitarbeitende-adressbuch-page',
  templateUrl: './adressbuch-list-page.component.html',
  styleUrls: ['./adressbuch-list-page.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    ReactiveFormsModule,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonMenuButton,
    IonButtons,
    TranslatePipe,
    InfoblockComponent,
    PrependServerToFileSrcPipe,
    RouterLink,
    IonRouterLink,
  ],
})
export class AdressbuchListPageComponent implements OnInit {
  users = signal<WorkUserV2[]>([]);

  private readonly exceptionHandlingService = inject(ExceptionHandlingService);
  private readonly workUsersV2Service = inject(WorkUsersV2Service);

  async ngOnInit() {
    await this.loadUsers();
  }

  private async loadUsers() {
    try {
      const paginatedResponse = await lastValueFrom(
        this.workUsersV2Service.usersV2ControllerFindAllPaginated({
          limit: 1000,
          'filter.active': ['$eq:1'],
          'filter.exitdate': [`$gte:${dayjs().format('YYYY-MM-DD')}`, `$or:$null`],
          'filter.entrydate': [`$lte:${dayjs().format('YYYY-MM-DD')}`],
        }),
      );
      this.users.set(paginatedResponse.data);
    } catch (loadUsersException) {
      this.exceptionHandlingService.handleExceptionWithAlert('loadUsersException', loadUsersException);
    }
  }
}
